/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ names: NonNullable<unknown> }} Sch_Err_Type_ReferencedInputs */

const en_sch_err_type_referenced = /** @type {(inputs: Sch_Err_Type_ReferencedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Other types or Fields are limited to this type alone (${i?.names}). Allow them on another type first.`)
};

const de_sch_err_type_referenced = /** @type {(inputs: Sch_Err_Type_ReferencedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Andere Typen oder Felder sind nur auf diesen Typ beschränkt (${i?.names}). Erlaube sie zuerst auch für einen anderen Typ.`)
};

/**
* | output |
* | --- |
* | "Other types or Fields are limited to this type alone ({names}). Allow them on another type first." |
*
* @param {Sch_Err_Type_ReferencedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_type_referenced = /** @type {((inputs: Sch_Err_Type_ReferencedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Type_ReferencedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_type_referenced(inputs)
	return en_sch_err_type_referenced(inputs)
});